Foundation.Mobile.Sizer = function () {
   // set cookies right now
   this.setCookies();

   // reset when window resizes
   jQuery(window).smartresize(this.setCookies);
}

Foundation.Mobile.Sizer.prototype.setCookies = function () {
    var cookies = Foundation.Mobile.Cookies;
    if (jQuery('body').width() != null) {
        cookies.setItem('gyrobase-screenwidth',  window.screen.availHeight, 600);
        cookies.setItem('gyrobase-screenheight',  window.screen.availWidth, 600);

        cookies.setItem('gyrobase-browserheight',  jQuery(window).height(), 600);
        cookies.setItem('gyrobase-browserwidth',  jQuery('body').width(), 600);
    }
    else {
        cookies.setItem('gyrobase-screenwidth',  window.screen.availHeight, 600);
        cookies.setItem('gyrobase-screenheight',  window.screen.availWidth, 600);

        cookies.setItem('gyrobase-browserheight',  jQuery(window).height(), 600);
        cookies.setItem('gyrobase-browserwidth',  jQuery(window).width() - 15, 600);
    }
};

/*
 * Utitliy for Sizer
 */
(function ($, sr) {
    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    var debounce = function (func, threshold, execAsap) {
        var timeout;

        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            }

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    }
    // smartresize
    jQuery.fn[sr] = function (fn) {  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
})(jQuery, 'smartresize');
